import React from 'react';
import { NavLink, Route, Switch } from "react-router-dom";
import Profile from './Profile';
import { setKey, clearKeys } from "../store/actions";
import Cookies from 'universal-cookie';
import keys from '../store/keys';
import { connect } from "react-redux";
import Purchases from './Purchases';
import Settings from "./Settings";
import ContactUs from './ContactUs';
import Returns from './Returns';

function Manage({ session, setKey, clearKeys, ...props }) {

	const handleLogout = e => {
		e.preventDefault();
		if (session.cookie) {
			const cookies = new Cookies();
			cookies.remove(session.cookie);
		}

		clearKeys();
		window.location.href = "/login";
	}


    return (
        <div className="row manage">
            <div className="col-2 left">

                <small>Welcome,</small>
                <p className="name mb-30">{session.user.firstname} {session.user.lastname}</p>

                <div className="nav flex-column nav-pills mb-100" aria-orientation="vertical">
                    <NavLink to="/manage/profile">
                        <i className="fa-solid fa-circle-user"></i>
                        My details
                    </NavLink>
                    <NavLink to="/manage/purchases">
                        <i className="fa-solid fa-bag-shopping"></i>
                        Purchases
                    </NavLink>
                    <NavLink to="/manage/returns">
                        <i className="fa-solid fa-arrow-rotate-left"></i>
                        Returns
                    </NavLink>
                    <NavLink to="/wishlist">
                        <i className="fa-solid fa-heart"></i>
                        Wishlist
                    </NavLink>
                    <NavLink to="/manage/settings">
                        <i className="fa-solid fa-cogs"></i>
                        Settings
                    </NavLink>
                    <hr />
                    <NavLink to="/manage/contact-us" className="mt-10">
                        <i className="fa-solid fa-headset"></i>
                        Contact Us
                    </NavLink>
                    <NavLink to="/login" onClick={handleLogout}>
                        <i className="fa-solid fa-arrow-right-from-bracket"></i>
                        Logout
                    </NavLink>
                </div>
            </div>
            <div className="col-10">
                <div className="container mb-100" style={{paddingTop: 10}}>
                <Switch>
                    <Route exact path='/manage/profile' component={Profile} />
                    <Route exact path='/manage/purchases' component={Purchases} />
                    <Route exact path='/manage/returns' component={Returns} />
                    <Route exact path='/manage/settings' component={Settings} />
                    <Route exact path='/manage/contact-us' component={ContactUs} />
                </Switch>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (store) => ({
	session: store.session,
});

const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	clearKeys: () => dispatch(clearKeys()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Manage);